module.exports = __webpack_public_path__ + "img/korean.a7ca108a.png";